import { PropsWithChildren, useCallback, useEffect, useState } from "react";
import { SheetContainerContext, SheetMeta } from "./SheetContainerContext";

export function SheetContainerProvider({ children }: PropsWithChildren) {
  const [enableTransitions, setEnableTransitions] = useState<boolean>(false);
  const [sheets, setSheets] = useState<SheetMeta[]>([]);

  const register = useCallback((id: string, isCollapsed: boolean) => {
    setSheets((prev) => {
      const isRegistered = prev.some((sheet) => sheet.id === id);
      return isRegistered ? prev : [...prev, { id, isCollapsed }];
    });
  }, []);

  const setIsCollapsed = useCallback((id: string, isCollapsed: boolean) => {
    setSheets((prev) =>
      prev.map((sheet) => (sheet.id === id ? { ...sheet, isCollapsed } : sheet))
    );
  }, []);

  const unregister = useCallback((id: string) => {
    setSheets((prev) => prev.filter((s) => s.id !== id));
  }, []);

  // Enable transitions after a short delay to allow initial rendering without transitions
  useEffect(() => {
    const timer = setTimeout(() => {
      setEnableTransitions(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <SheetContainerContext.Provider
      value={{
        sheets,
        register,
        unregister,
        setIsCollapsed,
        enableTransitions
      }}
    >
      {children}
    </SheetContainerContext.Provider>
  );
}
